<template>
  <div
    :class="isItems ? 'mini-cart mini-cart-shadow' : 'mini-cart'"
    v-if="showMiniCart"
  >
    <Tip
      :cartData="cartData"
      :isClose="drawer"
      :class="!isItems ? 'tip-bottom tip' : 'tip'"
      @close="handleClose"
      v-if="isTip"
    />
    <el-drawer
      v-if="isItems"
      :withHeader="false"
      :visible.sync="drawer"
      direction="btt"
      :size="'100%'"
      :modal="false"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :class="isTip ? 'cart-drawer' : 'cart-drawer cart-drawer-tip'"
    >
      <div v-if="drawer">
        <Tip
          :cartData="cartData"
          v-if="!cartData.favorTip"
          class="tip-none"
          @close="handleClose"
        />
        <div
          v-if="cartData.items && cartData.items.length"
          class="item-card"
          id="item-card"
        >
          <Card
            v-show="item.amount > 0"
            class="card"
            v-for="(item, index) in cartData.items"
            :class="item.mduType === 2 ? 'item-card-gift' : ''"
            :key="index"
            :itemCard="item"
            :cartData="cartData"
            :disabled="disabled"
            :isClose="isClose"
            :maxNum="maxNum"
            @change="handleChange"
            @cardSku="cardClick"
          />
        </div>
      </div>
    </el-drawer>
    <div class="mask-opacity-box" v-show="drawer" @click="handleClose"></div>
    <Bottom
      v-if="isItems"
      :isShow="!!isItems"
      :cartData="cartData"
      :class="!drawer && !isTip ? 'bottom close-bottom' : 'bottom'"
      :disabled="loading"
      :isClose="isClose"
      :drawer="drawer"
      @change="change"
      @check="check"
    />
  </div>
</template>

<script>
import Card from './card';
import Bottom from './bottom';
import Tip from './tip';
import { mapActions, mapState } from 'vuex';
import { stopScroll, openScroll } from '@/utils/baseUtil';
import { LOGIN_SOURCE_MAP, add_login_tag_logs_fun } from '@/const/logs';
import { getLocalStorage } from '@/utils/localStorage';
import passportMonitor from '@/utils/passportMonitor';

export default {
  name: 'MiniCart',
  props: {
    cartData: {
      type: Object,
      default: () => {},
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Card,
    Bottom,
    Tip,
  },
  data() {
    return {
      drawer: false,
      disabled: false,
      maxNum: 15,
    };
  },
  computed: {
    ...mapState({
      cartData: ({ cart }) => cart.cartInfo,
      loading: ({ cart }) => cart.loading,
      shopInfo: ({ store }) => store.shopInfo,
      isH5: ({ common }) => common.isH5,
    }),
    showMiniCart() {
      return this.isItems || this.isTip;
    },
    isItems() {
      return this.cartData?.items?.length;
    },
    isTip() {
      return this.cartData?.favorTip && +this.shopInfo?.cShopStatus === 1;
    },
    isCloseTip() {
      return this.cartData?.favorTip && +this.shopInfo?.cShopStatus === 1;
    },
    amountSum() {
      const arr = this.amountArr.reduce(function (prev, cur) {
        return prev + cur;
      }, 0);
      return arr;
    },
    amountArr() {
      let amountArr = [];
      this.cartData?.items?.forEach((item) => {
        amountArr.push(item.amount);
      });
      return amountArr;
    },
  },
  watch: {
    isItems(val) {
      if (val === 0) {
        this.drawer = false;
      }
    },
    amountSum(val) {
      this.disabled = val > 14 ? true : false;
    },
    drawer(val) {
      if (this.isH5 && !val) {
        openScroll();
      }
    },
  },
  mounted() {
    if (this.amountSum > 14) this.disabled = true;
  },
  methods: {
    ...mapActions('cart', ['setItemsAmount']),
    ...mapActions('common', ['getSidebar']),

    change() {
      this.drawer = !this.drawer;
      if (this.isH5 && this.drawer) {
        stopScroll();
      }
      if (this.drawer) {
        this.$trackEvent({
          eventId: 'sailing_c_x_cart_minicart_floating_layer_sw',
          eventLabel: 'mini购物车中菜品半浮层页曝光',
          attrs: {
            shop_id: this.cartData?.shopId,
            item_count: this.amountSum,
            subtotal: this.cartData?.prices?.itemFavorPriceDisplay,
            cart_id: this.cartData?.cartId,
          },
        });
      }
    },
    async check() {
      if (!getLocalStorage('isLogin')) {
        add_login_tag_logs_fun(LOGIN_SOURCE_MAP.shop_checkout);
        passportMonitor.login();
        return;
      }

      const res = await this.getSidebar();
      openScroll();
      if (res) {
        this.$router.push(
          `/bill/${this.cartData?.shopId}/${this.cartData?.cartId}`
        );
      }
    },
    handleClose() {
      this.drawer = false;
    },
    async handleChange(amount, item, isAdd) {
      this.maxNum = 15;
      this.disabled = false;
      this.$nextTick(async () => {
        if (this.amountSum > 14) {
          this.maxNum = Math.max.apply(null, this.amountArr);
          this.disabled = true;
          if (isAdd) {
            this.$utils.warningToast(this.$t('抱歉，您最多可加购15个菜品'));
            await this.setItemsAmount(item);
            return;
          }
        }
        await this.setItemsAmount(item);
        if (this.amountSum === 0 || !this.isItems) {
          this.drawer = false;
        }
      });
    },
    cardClick(item) {
      this.$trackEvent({
        eventId: 'sailing_c_x_cart_minicart_item_ck',
        eventLabel: 'mini购物车点击菜品名称',
        attrs: {
          shop_id: this.cartData?.shopId,
          item_id: item?.itemId,
          cart_id: this.cartData?.cartId,
        },
      });
      this.$emit('card-item', { ...item, cartId: this.cartData?.cartId });
    },
    setDrawer(val = false) {
      this.drawer = val;
    },
    getDrawer() {
      return this.drawer;
    },
  },
  destroyed() {
    openScroll();
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
@media screen and (min-width: 768px) {
  .mini-cart {
    .v-modal {
      background: rgba($color: #fff, $alpha: 0);
    }
  }
}

.mini-cart {
  .el-drawer {
    position: unset;
  }
  .cart-drawer-tip {
    border-radius: 8px 8px 0 0;
  }
  .el-drawer__wrapper {
    // border-radius: 8px 8px 0 0;
  }
  .el-drawer__open .el-drawer.btt {
    -webkit-animation: btt-drawer-in 0.1s 0.1ms;
    animation: btt-drawer-in 0.1s 0.1ms;
  }
  .el-drawer.btt {
    -webkit-animation: btt-drawer-out 0s;
    animation: btt-drawer-out 0s;
    bottom: 0;
  }
  .tip-bottom {
    dl {
      border-radius: 8px;
    }
  }
}
</style>
